/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  selector: 'ellf-select-field',
  template: `
    <ellf-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
      [tooltip]="tooltip"
    >
      <ellf-select
        [hasError]="shouldShowError"
        [formControl]="formControl"
        [bindValue]="bindValue"
        [clearable]="clearable"
        [bindLabel]="bindLabel"
        [multiple]="multiple"
        [placeholder]="placeholder"
        [searchable]="searchable"
        [items]="items"
        [canAdd]="canAdd"
        [canView]="canView"
        [readOnly]="readOnly"
      >
      </ellf-select>
    </ellf-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectFieldComponent extends BaseFormFieldComponent {
  @Input()
  placeholder = '';

  @Input()
  bindValue = 'value';

  @Input()
  bindLabel = 'description';

  @Input()
  multiple = false;

  @Input()
  searchable = false;

  @Input()
  clearable = false;

  @Input()
  items!: any[];

  @Input()
  canAdd? = false;

  @Input()
  canView? = false;

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.items) {
      throw new Error('items unspecified for autocomplete');
    }
  }
}
